// Sourced from metropolis/packages/profile-edit-ui/src/utils/mapBraidFieldProps/mapBraidFieldProps.ts

export const mapBraidFieldProps = <T extends object>({
  valid,
  errorMessage,
  value,
  highlightRanges,
  ...restProps
}: {
  valid: boolean;
  errorMessage: string;
  [key: string]: any;
} & T) => ({
  value,
  ...(!valid ? { tone: 'critical' as const } : {}),
  ...(errorMessage ? { message: errorMessage } : {}),
  ...(highlightRanges ? { highlightRanges } : {}),
  ...(restProps as T),
});
